module.exports = __webpack_public_path__ + "static/media/convex.712ce795.png";